<template>
  <div class="modal fade" id="modalViewCompleteLog" role="dialog">
    <div class="modal-dialog">
      <!-- Modal content-->
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal">&times;</button>
          <h4 class="title-modal">Visualizar informações completa do log.</h4>
        </div>

        <div class="modal-body">
          <div class="modal-footer">
            <button v-on:click="createTopExcel()" class="btn-excel">Excel</button>
          </div>
          <!-- Loading -->
          <div v-if="loadingListModal" class="loading center_vertical">
            <div class="loader-mini-box">
              <div class="spinner-box">
                <div class="rect1"></div>
                <div class="rect2"></div>
                <div class="rect3"></div>
                <div class="rect4"></div>
                <div class="rect5"></div>
              </div>
            </div>
          </div>

          <div v-if="!loadingListModal" class="content-align">
            <div class="align-inline-div">
              <p>deviceName: </p>
              <span>
              <span>{{ dataLog.deviceName }}</span>
            </span>
            </div>

            <div class="align-inline-div">
              <p>deviceModel: </p>
              <span>
              <span>{{ dataLog.deviceModel }}</span>
            </span>
            </div>

            <div class="align-inline-div">
              <p>deviceManufacturer: </p>
              <span>
              <span>{{ dataLog.deviceManufacturer }}</span>
            </span>
            </div>

            <div class="align-inline-div">
              <p>appVersion: </p>
              <span>
              <span>{{ dataLog.appVersion }}</span>
            </span>
            </div>

            <div class="align-inline-div">
              <p>appBuild: </p>
              <span>
              <span>{{ dataLog.appBuild }}</span>
            </span>
            </div>
          </div>

          <div v-if="!loadingListModal" class="content-align">
            <div class="align-inline-div">
              <p>deviceInfo: </p>
              <span>
              <span>{{ dataLog.deviceInfo }}</span>
            </span>
            </div>

            <div class="align-inline-div">
              <p>platformDevice: </p>
              <span>
              <span>{{ dataLog.platformDevice }} - {{ dataLog.platformDeviceStr }}</span>
            </span>
            </div>

            <div class="align-inline-div">
              <p>soVersion: </p>
              <span>
              <span>{{ dataLog.soVersion }}</span>
            </span>
            </div>

            <div class="align-inline-div">
              <p>logPointType: </p>
              <span>
              <span>{{ dataLog.logPointType }} - {{ dataLog.logPointTypeStr }}</span>
            </span>
            </div>

            <div class="align-inline-div">
              <p>logOfDay: </p>
              <span>
              <span>{{ dataLog.logOfDay }}</span>
            </span>
            </div>
          </div>

          <div v-if="!loadingListModal" class="content-align">
            <div class="align-inline-div">
              <p>Pode visualizar horas: </p>
              <span>
              <span v-if="dataLog.canBalance">Sim</span>
              <span v-else>Não</span>
            </span>
            </div>

            <div class="align-inline-div">
              <p>Device Permitido: </p>
              <span>
              <span v-if="dataLog.canDevice">Sim</span>
              <span v-else>Não</span>
            </span>
            </div>

            <div class="align-inline-div">
              <p>Modo Ponto Permitido: </p>
              <span>
              <span v-if="dataLog.canModePoint">Sim</span>
              <span v-else>Não</span>
            </span>
            </div>

            <div class="align-inline-div">
              <p>Sem GPS Permitido: </p>
              <span>
              <span v-if="dataLog.canNoGps">Sim</span>
              <span v-else>Não</span>
            </span>
            </div>

            <div class="align-inline-div">
              <p>Offline Permitido: </p>
              <span>
              <span v-if="dataLog.canOffline">Sim</span>
              <span v-else>Não</span>
            </span>
            </div>
          </div>

          <div v-if="!loadingListModal" class="content-align">
            <div class="align-inline-div">
              <p>Online: </p>
              <span>
              <span v-if="dataLog.canOnline">Sim</span>
              <span v-else>Não</span>
            </span>
            </div>

            <div class="align-inline-div">
              <p>QR Code Permitido: </p>
              <span>
              <span v-if="dataLog.canQrCode">Sim</span>
              <span v-else>Não</span>
            </span>
            </div>

            <div class="align-inline-div">
              <p>Visualizar Time Permitido: </p>
              <span>
              <span v-if="dataLog.canSeeTeam">Sim</span>
              <span v-else>Não</span>
            </span>
            </div>

            <div class="align-inline-div">
              <p>GPS: </p>
              <span>
              <span v-if="dataLog.isDevice">Sim</span>
              <span v-else>Não</span>
            </span>
            </div>

            <div class="align-inline-div">
              <p>Precisão do GPS: </p>
              <span>
              <span>{{ dataLog.gpsAccurate }}</span>
            </span>
            </div>
          </div>

          <div v-if="!loadingListModal" class="content-align">
            <div class="align-inline-div">
              <p>latitude: </p>
              <span>
              <span>{{ dataLog.latitude }}</span>
            </span>
            </div>

            <div class="align-inline-div">
              <p>longitude: </p>
              <span>
              <span>{{ dataLog.longitude }}</span>
            </span>
            </div>

            <div class="align-inline-div">
              <p>hasPoint: </p>
              <span>
              <span>{{ dataLog.hasPoint }}</span>
            </span>
            </div>

            <div class="align-inline-div">
              <p>address: </p>
              <span>
              <span>{{ dataLog.address }}</span>
            </span>
            </div>
            <div class="align-inline-div">
              <p>CameraDevice: </p>
              <span>
              <span>{{ dataLog.cameraDevice }}</span>
            </span>
            </div>

            <div class="align-inline-div">
              <p></p>
              <span>
              <span></span>
            </span>
            </div>
          </div>

          <!-- Tabela -->
          <div v-if="!loadingListModal" class="modal-table">
            <p class="total-log">Total de logs {{ logList.length }}</p>
            <div v-if="logList.length" class="mr-table">
              <div class="table-responsive table-clean col-md-12">
                <div class="modal-footer">
                  <button v-on:click="createExcel()" class="btn-excel">Excel</button>
                </div>
                <div class="table-scrollable table-scrollable-borderless">
                  <table class="table ">
                    <thead>
                    <tr>
                      <th class="certa"> ID Funcionário</th>
                      <th class="certa"> Funcionário</th>
                      <th class="certa"> Tipo do Log</th>
                      <th class="certa"> MS</th>
                      <th class="certa"> ID Obj</th>
                      <th class="certa"> Notas</th>
                      <th class="certa"> Data Ponto</th>
                      <th class="certa"> Data</th>
                      <th class="certa"> Error</th>
                      <th class="certa"> Razão</th>
                      <th class="certa"> Rota</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="e in logList">
                      <td>{{ e.userId }}</td>
                      <td>{{ e.userName }}</td>
                      <td>{{ e.pointLogTypeStr }}</td>
                      <td>{{ e.ms }}</td>
                      <td>{{ e.objectId }}</td>
                      <td>{{ e.notes }}</td>
                      <td>{{ e.datePoint | formatFullDate24 }}</td>
                      <td>{{ e.createdAt | formatFullDate24 }}</td>
                      <td>{{ e.error }}</td>
                      <td>{{ e.reason }}</td>
                      <td>{{ e.route }}</td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button v-on:click="closeModal()" class="close-btn">Fechar</button>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import {
  GET_POINT_LOG_REPORT_BY_ID
} from "../../../urlConfig";
import {
  REQUEST_SERVICE
} from "../../../requestConfig";
import {
  UTIL_SERVICE
} from "../../../requestConfig";
import {
  ALERT_SERVICE
} from "../../../msgAlertService";
import moment from "moment";

export default {
  name: "modalViewCompleteLog",
  props: ['callCheckRequest'],
  data() {
    return {
      loadingListModal: '',
      dataValue: {},
      logList: [],
      dataLog: {}
    }
  },
  methods: {
    createExcel() {
      let headValue = ["ID Funcionário", "Funcionário", "Tipo de Log", "MS", "ID Obj", "Notas", "Data Ponto", "Data", "Error", "Razão", "Rota"];
      let bodyValue = [];

      this.logList.map((value, index) => {
        bodyValue.push([value.userId || '-', value.userName || '-', value.pointLogTypeStr || '-', value.ms, value.objectId || '-', value.notes || '-', moment(value.datePoint).format('DD/MM/YYYY HH:mm') || '-', moment(value.createdAt).format('DD/MM/YYYY HH:mm') || '-', value.error ? 'sim' : 'não' , value.reason || '-', value.route || '-']);
      });

      window.downloadListExcel(headValue, bodyValue, "Informações de Log");
    },
    createTopExcel() {
      let headValue = ["deviceName", "deviceModel", "deviceManufacturer", "appVersion", "appBuild", "deviceInfo", "platformDevice", "soVersion", "logPointType", "logOfDay", "Device Permitido", "Sem GPS Permitido", "Offline Permitido", "Online", "Visualizar time Permitido", "GPS", "Precisão do GPS", "hasPoint", "address", "CameraDevice", "Total de logs xx"];
      let bodyValue = [];
      let arrayObject = this.dataLog;


      bodyValue.push([arrayObject.deviceName, arrayObject.deviceModel, arrayObject.deviceManufacturer, arrayObject.appVersion , arrayObject.appBuild || '-', arrayObject.deviceInfo || '-', arrayObject.platformDevice + '-' + arrayObject.platformDeviceStr || '-', arrayObject.soVersion || '-', arrayObject.logPointType + '-' + arrayObject.logPointTypeStr || '-', arrayObject.logOfDay || '-', arrayObject.canDevice ? 'Sim' : 'Não' || '-', arrayObject.canNoGps ? 'Sim' : 'Não' || '-', arrayObject.canOffline ? 'Sim' : 'Não' || '-', arrayObject.canOnline ? 'Sim' : 'Não' || '-', arrayObject.canSeeTeam ? 'Sim' : 'Não' || '-', arrayObject.isDevice ? 'Sim' : 'Não' || '-', arrayObject.gpsAccurate, arrayObject.hasPoint || '-', arrayObject.address || '-', arrayObject.cameraDevice, arrayObject.logList.length]);

      window.downloadListExcel(headValue, bodyValue, "Informações Adicionais de Log");
    },
    closeModal() {
      $('#modalViewCompleteLog').modal('toggle');
    },
    geDetail(id, contentString) {
      this.loadingListModal = true;

      this.dataLog = {};
      this.logList = [];
      let url = GET_POINT_LOG_REPORT_BY_ID + id;

      if (contentString) {
        url += "&contentString=" + contentString
      }

      REQUEST_SERVICE.get(url).then((response) => {
        UTIL_SERVICE.console("RESULT GET_POINT_LOG_REPORT_BY_ID:", response.data);

        this.loadingListModal = false;
        if (response.data) {
          this.dataLog = response.data;

          if (response.data.logList.length)
            this.logList = response.data.logList;
        }
      }).catch((reason) => {
        this.loadingListModal = false;
        this.failRequest = true;

        ALERT_SERVICE.showMsgError(reason.response.data.erros);
      });
    }
  },
  watch: {
    callCheckRequest: function (val) {
      this.dataValue = val;
      this.geDetail(val.id, val.contentString);
    }
  }
}
</script>

<style lang="scss">
#modalViewCompleteLog {
  .total-log {
    font-size: 16px;
    font-weight: 600;
  }

  .content-align {
    .align-inline-div {
      display: inline-block;
      width: calc(100% / 5);
      padding-bottom: 20px;
      float: left;

      p {
        margin-top: 0;
        text-align: center;
        min-height: 20px;
      }

      span {
        display: block;
        text-align: center;
        font-weight: bold;
        min-height: 50px;
        border-bottom: 1px solid #e4eef3;
      }
    }
  }

  .error-msg {
    font-size: 12px;
    color: #e74a4e;
    text-align: left;
    display: block;
  }

  .list-error {
    margin-top: 10px;

    .error-msg {
      display: block;
    }
  }

  @media (min-width: 768px) {
    .modal-dialog {
      width: 1000px;
      margin: 30px auto;
    }
  }

  .loader-mini-box {
    height: 120px;
    display: flex;
    flex-direction: column;
    justify-content: center;

    .spinner-box {
      height: 64px;
      text-align: center;

      .rect2 {
        -webkit-animation-delay: -1.1s;
        animation-delay: -1.1s;
      }

      .rect3 {
        -webkit-animation-delay: -1.0s;
        animation-delay: -1.0s;
      }

      .rect4 {
        -webkit-animation-delay: -0.9s;
        animation-delay: -0.9s;
      }

      .rect5 {
        -webkit-animation-delay: -0.8s;
        animation-delay: -0.8s;
      }

      > div {
        background-color: #3598dc;
        width: 4px;
        height: 64px;
        display: inline-block;
        -webkit-animation: sk-stretchdelay 1.2s infinite ease-in-out;
        animation: sk-stretchdelay 1.2s infinite ease-in-out;
        margin-right: 4px;
      }
    }
  }

  .modal-header {
    padding: 15px 15px 0;
    border-bottom: none;
  }

  .double-btn-center {
    display: block;
    margin: 0 auto 50px;

    .first {
      background: #00a651;
      color: #fff;
      border: none;
      padding: 20px 20px;
      border-radius: 4px !important;
      cursor: pointer;
      font-size: 16px;

      &:hover {
        background-color: #008d45;
      }
    }

    .second {
      background: #0F77AE;
      color: #fff;
      width: 49%;
      border: none;
      padding: 20px 20px;
      border-radius: 4px !important;
      cursor: pointer;
      font-size: 16px;

      &:hover {
        background-color: #054F91;
      }
    }

    .third {
      background: #c29d0b;
      color: #fff;
      border: none;
      width: 49%;
      margin-top: 30px;
      padding: 20px 20px;
      border-radius: 4px !important;
      cursor: pointer;
      font-size: 16px;

      &:hover {
        background-color: #aa890a;
      }
    }

    .four {
      background: #e74a4e;
      color: #fff;
      border: none;
      width: 49%;
      margin-top: 30px;
      padding: 20px 20px;
      border-radius: 4px !important;
      cursor: pointer;
      font-size: 16px;

      &:hover {
        background-color: #e43338;
      }
    }
  }

  .send-btn-modal {
    background: #3598dc;
    color: #fff;
    border: none;
    padding: 0 15px;
    height: 37px;
    border-radius: 4px !important;
    cursor: pointer;
    font-size: 16px;
    display: inline-block;
    margin: 0 auto 0 0;

    &:hover {
      background-color: #054F91;
    }
  }

  .modal-body {
    padding-left: 80px;
    padding-right: 80px;
    margin-top: 20px;
    margin-bottom: 20px;

    .detail-info {
      display: inline-block;
      width: 49%;
      min-height: 330px;

      h5 {
        margin: 0;

        span {
          margin: 0;
          font-weight: bold;
          letter-spacing: 1px;
          text-transform: uppercase;
          border-bottom: 1px solid;
          padding: 0 4px;
        }
      }

      p {
        span {
          font-weight: 600;
        }
      }
    }

    .detail-form {
      display: inline-block;
      width: 49%;
      float: right;

      h5 {
        margin: 0 0 20px;

        span {
          margin: 0;
          font-weight: bold;
          letter-spacing: 1px;
          text-transform: uppercase;
          border-bottom: 1px solid;
          padding: 0 4px;
        }
      }

      .form-group {
        margin-top: 15px;
      }
    }
  }

  .title-modal {
    text-align: center;
    padding-top: 10px;
    font-weight: bold;
    letter-spacing: 1px;
    text-transform: uppercase;
  }

  .modal-footer {
    .btn-excel {
      border-radius: 4px !important;
      background-color: #2acc6b;
      padding: 7px 35px 7px 35px;
      font-weight: 600;
      text-align: center;
      color: #fff;
      border: none;
      height: 36px;
      margin-right: -14px;
    }

    .close-btn {
      border-radius: 4px !important;
      background-color: #8b8787;
      padding: 7px 35px 7px 35px;
      font-weight: 600;
      text-align: center;
      color: #fff;
      border: none;
      height: 36px;
    }

    .btn-register {
      border-radius: 4px !important;
      background-color: #3598dc;
      padding: 7px 35px 7px 35px;
      font-weight: 600;
      text-align: center;
      color: #fff;
      border: none;
      height: 36px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/modals/modalViewCompleteLog.vue